'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dMeal$002dO$002dRama$002dApp$0024 from "./mealorama.-Meal-O-Rama-App$.js";
var $p;
function $s_Lmealorama_MealORamaApp__main__AT__V(args) {
  $j_mealorama$002e$002dMeal$002dO$002dRama$002dApp$0024.$m_Lmealorama_MealORamaApp$().aFk(args);
}
export { $s_Lmealorama_MealORamaApp__main__AT__V as $s_Lmealorama_MealORamaApp__main__AT__V };
//# sourceMappingURL=mealorama.-Meal-O-Rama-App.js.map
